import React from "react";

import Family from "components/Tvendo/Article/DataMaster/Family/List.js";

export default function () {
  return <Family />;
}
